module.exports = __webpack_public_path__ + "img/question-white.0ce98407.svg";